<template>

  <!-- Quiz Subjects Grid Block -->
  <items-loader
    no-autoload
    module="vlQuizSubjects"
    class="quiz-subjects-grid-block">

    <template
      slot-scope="{items}">

      <page-block
        bg-image-contain
        :bg-file="value.file"
        :bg-color="value.bgColor"
        :text-color="value.textColor"
        :text-align="value.textAlign"
        :width-class="value.widthClass"
        :overlay-class="value.paddingClass">

        <titled-text-element
          no-file
          no-body
          :value="value"/>

        <div
          class="grid-6 grid-gap-2">

          <quiz-subject-card
            :value="item"
            :key="item.id"
            class="hover-scale-2"
            v-for="item in items"
            @click="$router.push(`/quiz-subject/${item.slug}`)"/>

        </div>

      </page-block>

    </template>

  </items-loader>

</template>

<script>

  import {mapActions, mapMutations} from 'vuex';
  import PageBlock from '@src/components/page/page-block';
  import PageBlockMixin from '@src/mixins/page-block-mixin';
  import QuizSubjectCard from '@src/components/card/quiz-subject-card';
  import TitledTextElement from '@src/components/element/titled-text-element';

  export default {
    name: 'quiz-subjects-grid-block',
    mixins: [
      PageBlockMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      QuizSubjectCard,
      TitledTextElement,
    },
    methods: {
      ...mapActions('vlQuizSubjects', {
        fetch: 'FETCH_ITEMS',
      }),
      ...mapMutations('vlQuizSubjects', {
        resetWhere: 'RESET_WHERE',
      }),
    },
    mounted() {

      this.resetWhere();
      this.fetch();
    },
  };

</script>

<style lang="scss">

  .quiz-subjects-grid-block {
    color: inherit;
  }

</style>
